module.exports = __webpack_public_path__ + "static/media/login-left-bg.73531db3.png";